<template>
  <div class="information">
    <!-- <div class=""><img src="@/assets/my/head.jpg" alt=""></div> -->
    <div class="mess-con">
      <!-- <img src="@/assets/my/head.jpg" alt=""> -->
        <!-- <div class="mess-text">
        <div class="top-mess">{{Interformation.InformationExchange}}</div>
        <div class="top-message">{{Interformation.InformationExchangeTxt}}</div>
        </div> -->
    </div>
    <div class="info-top">
      <div class="process">
        <div class="module-title">
          {{applicationProcess.ApplicationProcess}}
        </div>
        <div class="cont">
          <div>
            <div class="name">{{applicationProcess.CompanyName}}</div>
            <el-input v-model="processData.enterpriseName" :placeholder="applicationProcess.CompanyNameTxt"></el-input>
          </div>
          <div>
            <div class="name">{{applicationProcess.title}}</div>
            <el-input v-model="processData.title" :placeholder="applicationProcess.titleTxt"></el-input>
          </div>
          <div>
            <div class="name">{{applicationProcess.Contact}}</div>
            <el-input v-model="processData.username" :placeholder="applicationProcess.ContactTxt"></el-input>
          </div>
          <div>
            <div class="name">{{applicationProcess.ContactDetails}}</div>
            <el-input v-model="processData.phone" :placeholder="applicationProcess.ContactDetailsTxt"></el-input>
          </div>
          <div class="btn-box">
            <div class="submit" @click="submit">{{applicationProcess.submit}}
              <img src="@/assets/img/enter.png" alt="">
            </div>
            <div class="reset" @click="reset">{{applicationProcess.Reset}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      processData: {
        enterpriseName: '',
        title: '',
        username: '',
        phone: ''
      }
    }
  },
  computed:{
    applicationProcess(){
      return this.$t('applicationProcess')
    }
  },
  methods: {
    submit() {
      window.location.href = `mailto:wangkehan@caict.ac.cn?subject=${this.processData.title}&body=企业名称：${this.processData.enterpriseName}%0a%0d联系人：${this.processData.username}%0a%0d联系方式：${this.processData.phone}%0a%0d`;
    },
    reset() {
      this.processData = {
        enterpriseName: '',
        title: '',
        username: '',
        phone: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.information {
  width: 100%;
  // background: url(@/assets/my/head.jpg) no-repeat;
  // background-size: 100% auto;
  // padding-top: 15%;
  // padding-top: 20px;
  box-sizing: border-box;
  .mess-con {
    height: 180px;
    max-width: 1200px;
    margin: 0 auto;
    background: url('@/assets/my/head.jpg') no-repeat;
    background-size: 100% 100%;
  }
  .info-top {
    // position: relative;
    img {
      width: 100%;
    }
    .process {
      max-width: 1200px;
      margin: 0 auto;
      margin-bottom: 100px;
      // position: absolute;
      // top: 30px;
      // left: 50%;
      // transform: translateX(-50%);
      padding: 4% 10%;
      box-sizing: border-box;
      background: #FFF;
      box-shadow: 0px 4px 15px 6px rgba(0,0,0,0.06);
      .module-title {
        text-align: center;
        font-size: 32px;
        color: #000;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .cont {
        margin-top: 60px;
        >div {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .name {
            width: 155px;
            white-space: nowrap;
            text-align: right;
            margin-right: 20px;
          }
        }
        .btn-box {
          display: flex;
          justify-content: center;
          margin-top: 60px;
          >div {
            width: 150px;
            height: 34px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .submit {
            background: #1B3E92;
            color: #FFF;
            margin-right: 30px;
            img {
              width: 10px;
              margin-left: 10px;
            }
          }
          .reset {
            border: 1px solid #C8CBD3;
            color: #61656C;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
@media (max-width: 600px) {
  .mess-con {
    height: 150px !important;
  }
}
</style>